import React, { useEffect, useState } from 'react';
import entities from '../../utils/entities';
import { Button,Container, Col,Row } from 'reactstrap';
import { useParams } from 'react-router-dom';
import Editor from '../Models/Editor';
import { useFetchEntity } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';
import SelectorNoForm from '../Form/SelectorNoForm';
import { FormLabel } from '../Form/FormLabel';
import useFetch from '../../Services/useFetch';
import LoadingAnimation from '../Form/LoadingAnimation';


const EntityTransitionButton = ({ onClick }) => {
    const [entity, setEntity] = useState();
    const [allEntities, loadingEntities, errorEntities] = useFetch(endpoints.getAllEntities);
    const [changeEvents, loadingsc, errorsc] = useFetch(entity ? endpoints.getStatusChangeEventsForEntity + entity : null);
    const [selection, setSelection] = useState();
    const [options, setOptions] = useState();
    const [entityOptions, setEntityOptions] = useState();
    const [entitySelection, setEntitySelection] = useState();
    useEffect(() => {
        allEntities && setEntityOptions(allEntities.map(x => { return { label: x, value: x } }));
    }, [allEntities]);
    useEffect(() => {
        if (changeEvents) {
            const newOptions = changeEvents.map(x => { return { label: x.fromState + '➡' + x.newState, value: { entity: entity, fromState: x.fromState, newState: x.newState } } });
            setOptions(newOptions);
        }
    }, [changeEvents,entity]);
    useEffect(() => {
        if (entitySelection) {
            setEntity(entitySelection.value);
            setOptions([]);
            setSelection();
        }
    }, [entitySelection]);

    const addItem = () => {
        onClick({ entityType: entity, ...selection.value });
    }

    return <React.Fragment>
        {loadingEntities|| loadingsc? <LoadingAnimation /> : null}
        {errorEntities ? <h6>Error Loading entities</h6> : null}
        {errorsc ? <h6>Error Loading State Change Events</h6>:null}
        <Container>
            <Row>
                <Col>
                    <FormLabel>When</FormLabel>
                </Col>
                <Col>
                    {entitySelection ? <FormLabel>Changes</FormLabel>:null}
                </Col>
                <Col>
                    {selection ? <FormLabel>Add</FormLabel> : null}
                </Col>
            </Row><Row>
                <Col>
                    <SelectorNoForm onChange={(e) => setEntitySelection(e)} value={entitySelection} options={entityOptions} />
                </Col>
                <Col>
                    {entitySelection ? <SelectorNoForm onChange={(e) => setSelection(e)} value={selection} options={options} /> : null}
                </Col>
                <Col>
                    {selection ? <Button onClick={()=>addItem()}>Add</Button> : null}
                </Col>
            </Row>
        </Container>
    </React.Fragment>

}
const ManageMessage = ({ route,type }) => {
    const [stateChangeItemId, setStateChangeItemId] = useState(); 
    const [newStateChangeEvent, setNewStateChangeEvent] = useState();
    const parms = useParams();
    const [events, loading, error] = useFetchEntity(entities.stateChangeEvent,parms);
    const [viewState, setViewState] = useState();
   const editorStateClosed = () => {
        setStateChangeItemId();
        setNewStateChangeEvent();
    }
    useEffect(() => {
        if (events) {
            let set = {};
            events.filter(x=>x.notificationType !=='System').map(x => {
                set[x.entityType] = set[x.entityType] ? [...set[x.entityType],x] : [x];
                return null
            });
            setViewState(set)
        }


    }, [events]);
    const addNew = (x) => {
        setNewStateChangeEvent(x);
    }

    return <React.Fragment>
        {loading ? <LoadingAnimation /> : null}
        {error ? <h6>Error Loading Event</h6>:null}
        <Editor route={route + '/' + type} entity={entities.stateChangeEvent} itemId={stateChangeItemId} newItem={newStateChangeEvent} editorClosed={editorStateClosed}>
        </Editor>
        <EntityTransitionButton  onClick={(x) => addNew(x)} />
         <h1>{type}</h1>
        {viewState ? Object.keys(viewState).map((x, i) => {
            const v = viewState[x];
          
            return <React.Fragment key={i}><h1>{x}</h1>;
            {v.map((va,i) => {
                const email = va.notificationType === 'Email' ? '📧' : va.notificationType === 'Notification' ? '⚡︎' : va.notificationType === 'System' ? '🖥' : '☏';
                return <React.Fragment key={i}>
                    <h2>{va.fromState + "=>" + va.newState}</h2>
                    <Button onClick={() => setStateChangeItemId(va.id)} active>{email}{va.name}</Button>
                </React.Fragment>
            })}

            </React.Fragment>;
        }) : null}

    </React.Fragment>

}
export default ManageMessage;

